import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiUser } from "../../api/user";
import { ErrorData } from "../interfaces";

export const allUser = createAsyncThunk<any,string,{rejectValue:ErrorData}>(
    'user/get/all',
    async (nama_sistem:string, { rejectWithValue }) => {
        try {
            const res : any = await ApiUser.get(nama_sistem)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const addUser = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'user/add',
    async (data : any, { rejectWithValue }) => {
        try {
            const res : any = await ApiUser.post(data)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const editSelf = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'user/self/edit',
    async (data:any, { rejectWithValue }) => {
        try {
            const res : any = await ApiUser.updateSelf(data)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const editByAdmin = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'user/edit',
    async (data:any, { rejectWithValue }) => {
        try {
            const res:any = await ApiUser.update(data.uuid, data.update)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const dropUser = createAsyncThunk<any,string,{rejectValue:ErrorData}>(
    'user/delete',
    async (uuid:string, { rejectWithValue }) => {
        try {
            const res :any = await ApiUser.delete(uuid)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const addSistem = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'sistem/add',
    async (data:any, { rejectWithValue }) => {
        try {
            const res:any = await ApiUser.postSistem(data.uuid, data.post)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const dropSistem = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'sistem/delete',
    async (data:any, { rejectWithValue }) => {
        try {
            const res:any = await ApiUser.deleteSistem(data.uuid, data.uuid_sis)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }
    }
)
export const editSistemOne = createAsyncThunk<any,any,{rejectValue:ErrorData}>(
    'sistem/edit/one',
    async (data:any, { rejectWithValue }) => {
        try {
            const res = await ApiUser.updateSistem(data.uuid, data.uuid_sistem, data.update)
            if (res.status === 200) {
                return res.data
            }
        }
        catch (err:any) {
            return rejectWithValue({message:err.response.data.msg})
        }

    }
)